import(/* webpackMode: "eager" */ "/vercel/path0/app/ningenie/page.tsx");
